import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {STATS} from "../game-stats-widget.consts";
import type {GameStatsWidgetState} from "../models/game-stats-widget.state";
import {GameStatsWidgetActualPlayTimeDisplayEvent} from "../models/game-stats-widget.actual-play-time.display.event";

export class GameStatsWidgetActualPlayTimeDisplayEventHandler extends AnalyticsEventHandler {
  state: GameStatsWidgetState;
  type = STATS.ACTION_TYPES.actualPlayTimeDisplayHandler;

  static injectables = [...ActionHandler.injectables, AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = GameStatsWidgetActualPlayTimeDisplayEvent;
  }
}
